
const digest = 'cfd7b37016233447f39f0dd645f90dcdc38d252ed9d5c0ec1fb22c26b416c69b';
const classes = {"wrapper":"_wrapper_1rign_1","greyBox":"_greyBox_1rign_15","whiteBox":"_whiteBox_1rign_28"};
const css = `._wrapper_1rign_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: -34px -24px;
}
._wrapper_1rign_1 span {
  font-weight: 600;
}
._wrapper_1rign_1 img {
  height: 50px;
}
._wrapper_1rign_1 ._greyBox_1rign_15 {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f4f7;
  padding: 24px;
  width: 100%;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1rign_1 ._greyBox_1rign_15 p {
  margin-bottom: 0;
}
._wrapper_1rign_1 ._whiteBox_1rign_28 {
  padding-bottom: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  